export interface FeatureFlags {
  [key: string]: boolean | undefined;
}

export const COLOR_INDICATORS_FLAG = 'metricsColorIndicatorsEnabled';
export const CONSTANT_COMPARISONS_FLAG = 'metricsReferenceLineEnabled';
